<div *ngIf="!isChromeBrowser" fxLayoutAlign="center center" fxLayout="column" class="warning">
    <label class="first-warning-label"> The experience is optimized for Google Chrome.</label>
    <a class="second-warning-label" download href="https://www.google.com/chrome" >Download Google Chrome.</a>
</div>